import * as React from "react";

function SvgLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.94 21"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M-.02 10.54l10 10a1.65 1.65 0 001.12.45 1.54 1.54 0 001.13-.45 1.58 1.58 0 000-2.19l-6.25-6.23h16.39a1.59 1.59 0 001.61-1.58 1.53 1.53 0 00-1.61-1.55H5.98l6.21-6.25a1.66 1.66 0 000-2.26A1.63 1.63 0 009.98.45z" />
    </svg>
  );
}

const MemoSvgLeft = React.memo(SvgLeft);
export default MemoSvgLeft;
